<div class="row">
  <div class="col-md-12">
    <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
      <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
        <mat-card-title class="mat-mdc-card-title text-white">
          {{ 'HowToCutSticks'|translate }}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="mat-mdc-card-content text-center">
        <span class="tilte">{{ 'RequiredProductsData'|translate }}</span>
        <div class="row">
          <div class="col-lg-6 m-t-10" *ngFor="let cost of TotalCostInputData;let i =index">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
              <mat-card-content class="mat-mdc-card-content text-right">
                <div class="row">
                  <div class="col-md-2">
                    <img class="m-auto ms-5 product-img"
                         src="{{cost.subCategoryImage | adjust_image_path }}">
                  </div>
                  <div class="col-md-9  m-l-10">
                    <span class="TypeName"> {{ cost.typeName }}</span>

                    <table class="w-100 m-b-20">
                      <tr>
                        <td>
                                                    <span class="span-title">{{ 'Color' | translate }} :
                                                    </span>
                          <span>{{ cost.colorName }} </span>
                        </td>
                        <td>
                                                    <span class="span-title">{{ 'Length' | translate }} :
                                                    </span>
                          <span>{{ cost.height }} {{ 'Meter' | translate }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                                                    <span class="span-title"> {{ 'width' | translate }} :
                                                    </span>
                          <span>{{ cost.width }} {{ 'Meter' | translate }}</span>
                        </td>
                        <td>
                                                    <span class="span-title">{{ 'NumberOfMeters' | translate }} :
                                                    </span>
                          <span>{{ ClacNumberOfMeters(cost.width, cost.height) }}
                            {{ 'squareMeter'|translate }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <span class="span-title">{{ 'RequiredCount' | translate }} : </span>
                          <span>{{ cost.count ?? 1 }}</span>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>

        <span class="tilte">{{ 'HowToCutSticks'|translate }}</span>
        <div class="row">
          <ng-container *ngFor="let ingredient of OrderInfoData.ingredientsInfo;let i=index">
            <div class="col-lg-6 m-t-20 m-b-15" *ngIf="ingredient?.rolls">
              <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
                <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
                  <mat-card-title class="mat-mdc-card-title text-white">
                    {{ ingredient?.product?.tblProductName?.name }}
                  </mat-card-title>
                </mat-card-header>
                <mat-card-content class="mat-mdc-card-content text-right">
                  <table class="w-100 m-b-20">
                    <tbody>
                    <tr>
                      <td>
                        <span class="span-title">{{ 'OudsCount'|translate }} :</span>
                        <span>{{ ingredient.numRollsUsed }} </span>
                      </td>
                      <td>
                        <span class="span-title">{{ 'OudHeight'|translate }} :</span>
                        <span>{{ ingredient?.product?.metersPerRod }}
                          {{ 'Meter'|translate }}</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>

                  <table class="table w-100 m-t-10">
                    <thead>
                    <tr>
                      <th class="th-title">{{ 'T'|translate }}</th>
                      <th class="th-title">{{ 'Cutting'|translate }}</th>
                      <th class="th-title">{{ 'wastes'|translate }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let roll of ingredient?.rolls;let i =index">
                      <td>{{ i + 1 }}</td>
                      <td>
                                                    <span *ngFor="let roll2 of roll;let isLast =last">
                                                        {{ roll2 }} <span *ngIf="!isLast">-</span>
                                                    </span>

                      </td>
                      <td>{{ ingredient?.wastes![i] }}</td>
                    </tr>
                    </tbody>
                  </table>
                </mat-card-content>
              </mat-card>
            </div>
          </ng-container>
        </div>
        <mat-divider></mat-divider>
        <div class="row m-t-24">
          <div class="col-sm-12">
            <div class="calc-cost-actionbar">
              <button class="btn orangecolorbtn" (click)="exportPDF()"> {{ 'exportPDF'|translate }}</button>

              <a (click)="Cancel()" class="btn btnClose">
                {{ 'Back' | translate }}
              </a>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
